import React from 'react'
import PropTypes from 'prop-types'
import {format, addDays, startOfWeek, startOfMonth, isSameDay, isSameMonth, isAfter, isBefore} from 'ag-common/facades'
import _ from 'lodash'
import DatePickerTableHeaderCell from './DatePickerTableHeaderCell'
import DatePickerCell from './DatePickerCell'

const HeaderLine = () =>
  _.range(0, 7).map(n => (
    <DatePickerTableHeaderCell
      key={`date-picker-table-header-${n}`}
      text={format(addDays(startOfWeek(new Date(), {weekStartsOn: 1}), n), 'dd')}
    />
  ))

export const Content = (showDate, startDate, endDate, onClick) => {
  const visibleMonthStart = startOfWeek(startOfMonth(showDate), {weekStartsOn: 1})
  return _.range(0, 42).map(n => Cell(n, addDays(visibleMonthStart, n), showDate, startDate, endDate, onClick))
}

export function Cell(n, cellDate, showDate, startDate, endDate, onClick) {
  const isActive = isSameMonth(cellDate, showDate)
  const isSelected = isSameDay(cellDate, startDate) || isSameDay(cellDate, endDate)
  const isMarked = !isSelected && isAfter(cellDate, startDate) && isBefore(cellDate, endDate)
  return (
    <DatePickerCell
      key={`date-picker-cell-${n}`}
      date={cellDate}
      isActive={isActive}
      marked={isMarked}
      selected={isSelected}
      onClick={() => onClick(cellDate)}
    />
  )
}

function DatePickerCalendar({showDate, startDate, endDate, onCellClicked}) {
  return (
    <div className="date-picker-calendar">
      {HeaderLine()}
      {Content(showDate, startDate, endDate, onCellClicked)}
    </div>
  )
}

DatePickerCalendar.propTypes = {
  showDate: PropTypes.instanceOf(Date),
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  onCellClicked: PropTypes.func,
}

export default DatePickerCalendar
